export type SimpleFieldType = 'text' | 'number' | 'date' | 'boolean' | 'other'

const FIELD_TYPE_MAPPINGS: Record<string, string> = {
  String: 'text',
  UInt64: 'number',
  UInt32: 'number',
  UInt16: 'number',
  UInt8: 'number',
  Int64: 'number',
  Int32: 'number',
  Int16: 'number',
  Int8: 'number',
  Float64: 'number',
  Float32: 'number',
  Bool: 'boolean',
  Date: 'date',
  Date32: 'date',
  Date64: 'date',
  DateTime: 'date',
  Timestamp: 'date',
  Time: 'date',
  Array: 'array',
}
export const mapFieldTypeToHumanReadable = (
  fieldType: string
): {
  isArray: boolean
  type: string
} => {
  const isArray = fieldType.includes('Array')

  const fieldTypeCleaned = fieldType
    .replace(/^Nullable\((.+)\)$/, '$1')
    .replace(/^Array\((.+)\)$/, '$1')
  return {
    isArray,
    type: FIELD_TYPE_MAPPINGS[fieldTypeCleaned] || 'other',
  }
}
